// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e3bc51dd","92":"091e4b31","125":"21e9bfbf","129":"a16f4f5e","345":"48c2c728","628":"84225faa","672":"6261abb5"}[chunkId] + ".chunk.js";
};